import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useSelector } from "react-redux";
import { SEARCH_MODEL } from "../../table/Model/TableModel";
import {TAB_PANEL_MODEL} from "../Model/TabPanelModel";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Generic per-section tab state hook for an Add/Assigned resource panel. Owns
 * the active tab, the available-search results, the search inputs and the
 * delete trigger. Domain-agnostic: reused by every module's shift-resource
 * sections through TabPanel. One instance per section.
 *
 * @param {number|string} [initialTab=0] - Initial active tab (key or index)
 *   provided by the consuming module; defaults to the first (Add) tab.
 * @returns {Object} Tab state and setters.
 */
export const TabPanelApp = (initialTab = TAB_PANEL_MODEL.ADD) => {
    const { t } = useTranslation();

    const [subViewChild, setSubViewChild] = useState(initialTab);
    const [results, setResults] = useState(SEARCH_MODEL.clearResults());
    const [, setBodyForExport] = useState(null);
    const [searchElement, setSearchElement] = useState('');
    const [, setSearch] = useState(false);
    const [, setSimpleSearch] = useState(false);
    const [modified, setModified] = useState(false);
    const [triggerDelete, setTriggerDelete] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    return {
        t, permission,
        subViewChild, setSubViewChild,
        results, setResults,
        setBodyForExport,
        searchElement, setSearchElement,
        setSearch,
        setSimpleSearch,
        modified, setModified,
        triggerDelete, setTriggerDelete,
        isAllChecked, setIsAllChecked,
    }
}

export default TabPanelApp
